//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { parse } from 'query-string'
import { mapGetters } from 'vuex'

import SkinnyBanner from '@core/components/SkinnyBanner'
import { removeEmptyValuesInObject } from '@core/helpers'
import { getDevice } from '@tracking'

import SearchParams, { getSourceFromRouteName } from '../../utils/SearchParams'
import ProductResultsSection from '../ProductResults/ProductResultsSection'

export const fetch = async ({ store, $config, route }) => {
  const country = store.getters['config/country']
  const { FF_NEW_URL_FORMAT } = $config
  const useNewUrl = FF_NEW_URL_FORMAT.includes(country)

  // Note that the hash is not available server-side, but is client-side.
  const { query, hash, name, params } = route
  const source = getSourceFromRouteName(name)

  store.dispatch('landing/reset')

  await store.dispatch('landingSearch/fetchResults', {
    searchParams: new SearchParams({
      query,
      hash,
      context: {
        source,
        slug: useNewUrl ? params.merchantName : params.category,
        id: useNewUrl ? params.uuid : params.id,
      },
      paramsWhitelist: store.getters['landingSearch/filterWhitelist'],
      tags: [getDevice(), source],
    }),
  })
}

export default {
  components: {
    SkinnyBanner,
    ProductResultsSection,
  },

  data() {
    return {
      isLoading: false,
    }
  },

  computed: {
    ...mapGetters({
      country: 'config/country',
      isSkinnyBannerAvailable: 'countryConfig/isSkinnyBannerAvailable',
      filterWhitelist: 'landingSearch/filterWhitelist',
      searchHasResults: 'landingSearch/hasResults',
      isCurrentContextId: 'landingSearch/isCurrentContextId',
    }),
    useNewUrl() {
      return this.$config.FF_NEW_URL_FORMAT.includes(this.country)
    },
    searchContext() {
      const { params, name } = this.$route

      return removeEmptyValuesInObject({
        source: getSourceFromRouteName(name),
        slug: this.useNewUrl ? params.merchantName : params.category,
        id: this.useNewUrl ? params.uuid : params.id,
      })
    },
    searchParams() {
      const { query, hash, name } = this.$route

      return new SearchParams({
        query,
        hash,
        context: this.searchContext,
        paramsWhitelist: this.filterWhitelist,
        tags: [getDevice(), getSourceFromRouteName(name)],
      })
    },
    searchFilters() {
      return this.searchParams.toFilters()
    },
    hasResultsOrFilters() {
      return this.searchHasResults || this.searchParams.hasUserFilters()
    },
    shouldDisplayResults() {
      return (
        this.hasResultsOrFilters &&
        this.isCurrentContextId(this.searchParams.contextId)
      )
    },
  },
  // Needs to call it client side, to manage the hash param
  // That's the reason why we disable the fetch method client side (duplicate)
  watch: {
    $route: {
      immediate: true,
      handler() {
        this.fetchSearchResults()
      },
    },
  },

  methods: {
    async fetchSearchResults() {
      this.isLoading = true

      await this.$store.dispatch('landingSearch/fetchResults', {
        searchParams: this.searchParams,
      })

      this.isLoading = false
    },

    updateQueryString(filter) {
      const filters = {
        ...this.searchFilters,
        // Move back the page to 1 when we change the filters
        page: 1,
        context: this.searchContext,
        paramsWhitelist: this.filterWhitelist,
        ...filter,
      }

      const query = SearchParams.fromFilters(filters).toQueryParams()

      this.updateURLFromFilters(query)
    },

    resetFilters() {
      // SearchLanding: resetting filters shouldn't affect the q param
      const { q } = this.searchFilters
      this.updateURLFromFilters({
        ...(q && { query: { q } }),
      })
    },

    updateURLFromFilters({ hash, query }) {
      this.$navigation.push({
        name: this.$route.name,
        params: this.$route.params,
        hash: parse(hash),
        query,
        type: 'internal',
      })
    },
  },
}
